<template>
  <div class="home">
    <HomeHero />
    <div class="helo">
      <Hello />
    </div>
    <div class="whySection">
      <WhyKwanzaa
        class="whykwanzaa"
        v-for="detail in details"
        :key="detail.index"
        :whyImage="detail.whyImage"
        :whyHeader="detail.whyHeader"
        :whyDesc="detail.whyDesc"
      />
      <HowItWorks />
    </div>
    <Footer />
  </div>
</template>

<script>
import HomeHero from "../components/HomeHero";
import Hello from "../components/Hello";
import WhyKwanzaa from "../components/WhyKwanzaa";
import HowItWorks from "../components/HowItWorks";
import Footer from "../components/layouts/Footer";
export default {
  name: "Home",
  components: {
    HomeHero,
    Hello,
    WhyKwanzaa,
    HowItWorks,
    Footer
  },
  data() {
    return {
      details: [
        {
          whyImage: require("../assets/Home/WhySection/tested.png"),
          whyHeader: "Tested Everyday",
          whyDesc:
            "Scientific quality testing of milk for adulteration at every stage.",
        },
        {
          whyImage: require("../assets/Home/WhySection/3_degrees.png"),
          whyHeader: "Kept at 3-8°C",
          whyDesc:
            "Maintaining milk at 3-8°C improves shelf life and prevents increase in bacteria counts.",
        },
        {
          whyImage: require("../assets/Home/WhySection/hassle_free.png"),
          whyHeader: "Hassle Free",
          whyDesc: "Scheduled or on-demand. Freeze your membership anytime.",
        },
      ],
    };
  },
};
</script>
<style scoped>
.home{
  max-width: 1400px;
  margin: auto;
}
/* .helo{
  height: 1300px;
} */
.whySection {
  /* width: 90%; */
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.whykwanzaa {
  flex: 200px;
  margin: 20px;
}
</style>